import React from 'react';
import { Carousel } from 'react-bootstrap';
import YouTube from 'react-youtube';
import { Link } from '@tanstack/react-router';
import styles from './Hero.module.scss';

const Hero = ({ destination, onOpenPlanner }) => {
  const images = (destination?.images?.home || []).slice(0, 3);
  const isMultipleImages = images.length > 1;
  const youTubeVideoId = destination?.youTubeUrl
    ? destination.youTubeUrl.split('=')[1]
    : '';

  const opts = {
    width: '100%',
    height: '100%',
    playerVars: {
      autoplay: 1,
      controls: 0,
      loop: 1,
      mute: 1,
      modestbranding: 1,
      fs: 0,
    },
  };

  return (
    <header className={styles.hero}>
      <div className={styles.bg} />
      <div className={styles.carousel}>
        {youTubeVideoId ? (
          <YouTube
            className={styles.carousel}
            videoId={youTubeVideoId}
            opts={opts}
          />
        ) : (
          <Carousel
            controls={isMultipleImages}
            indicators={isMultipleImages}
            interval={isMultipleImages ? 5000 : null}
            pause={false}
          >
            {(images.length ? images : [{ _id: 'fallback' }]).map((image, index) => (
              <Carousel.Item key={image._id} style={{ height: '100%' }}>
                {image.url && (
                  <img
                    className={styles.image}
                    src={image.url}
                    alt={image.title || destination?.name}
                    fetchPriority={index === 0 ? 'high' : 'auto'}
                    loading={index === 0 ? 'eager' : 'lazy'}
                    decoding="async"
                  />
                )}
              </Carousel.Item>
            ))}
          </Carousel>
        )}
      </div>
      <div className={styles.scrim} />

      {/* <span className={styles.recommended}>★ Recommended</span> */}

      <div className={styles.content}>
        <div className={styles.kicker}>
          {destination?.heroText?.home?.eyebrow || `The Original ${destination?.name || ''} Guide`}
        </div>
        {destination?.heroText?.home?.title || destination?.mainHeader ? (
          <h1
            className={styles.title}
            dangerouslySetInnerHTML={{ __html: destination?.heroText?.home?.title || destination?.mainHeader || destination?.name || '' }}
          />
        ) : (
          <h1 className={styles.title}>{destination?.name}</h1>
        )}
        {(destination?.heroText?.home?.subtext || destination?.mainSub) && (
          <p className={styles.subtitle}>{destination?.heroText?.home?.subtext || destination?.mainSub}</p>
        )}
        <div className={styles.actions}>
          <button className={styles.primaryBtn} onClick={() => onOpenPlanner?.()}>
            Design your Safari  →
          </button>
          <Link to="/accommodation" className={styles.secondaryBtn}>
            Accommodation Listings →
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Hero;
